import { FilterButton } from 'omakase';
import { FunctionComponent } from 'react';
import { IconLocationFilled } from '@tock/icons';

export interface PatronLocationComponentProps {
  loading?: boolean;
  locationText?: string;
  onClick?(e: React.MouseEvent<HTMLElement>): void;
}

export const PatronLocationDesktopSearchResultsButton: FunctionComponent<
  PatronLocationComponentProps
> = ({ loading = false, locationText, onClick }) => {
  return (
    <FilterButton
      aria-haspopup
      aria-label="Change location"
      css={{
        maxWidth: '250px',
      }}
      disabled={loading}
      onClick={onClick}
      selected={!loading && !!locationText}
      iconStart={<IconLocationFilled fontSize="small" />}
      data-testid="change-location-button-desktop-search-results"
    >
      {loading ? 'Loading' : locationText}
    </FilterButton>
  );
};
